import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ITela} from '../../objeto/ITela';
import {NpsService} from '../../services/nps.service';

@Component({selector: 'app-tela-avaliar-nps', templateUrl: './tela-avaliar-nps.component.html', styleUrls: ['./tela-avaliar-nps.component.scss']})
export class TelaAvaliarNpsComponent implements OnInit, ITela {
  token = '';
  avaliacao: any;
  resposta: {nota: number | null; comentario: string} = {nota: null, comentario: ''};
  notas = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  carregando = false;
  enviando = false;
  enviado = false;
  msgErro = '';
  private contexto = 0;
  private iniciou = false;
  constructor(route: ActivatedRoute, private nps: NpsService) {
    route.params.subscribe(params => {
      this.token = params.token || '';
      if (this.iniciou) this.carregueAvaliacao();
    });
  }
  ngOnInit() {this.iniciou = true; this.carregueAvaliacao();}
  deveExibirTopo() {return false;}
  deveExibirMenu() {return false;}
  deveTerBordas() {return false;}
  deveExibirBannerTema() {return false;}
  fecheTela() {}
  /** A pergunta aberta acompanha a nota escolhida, sem sugerir qual nota dar. */
  get perguntaComentario(): string {
    const nota = this.resposta.nota;
    if (nota === null) return 'Qual é o principal motivo da sua nota?';
    if (nota <= 6) return 'O que mais precisamos melhorar?';
    if (nota <= 8) return 'O que faltou para a sua nota ser 10?';
    return 'O que você mais valoriza no PromoKit?';
  }
  get ajudaComentario(): string {
    const nota = this.resposta.nota;
    if (nota !== null && nota <= 6) return 'Conte o que aconteceu. Nossa equipe lê cada comentário.';
    if (nota !== null && nota >= 9) return 'Pode ser algo do sistema ou do atendimento da equipe.';
    return 'Compartilhe o que está funcionando bem ou o que podemos melhorar.';
  }
  selecioneNota(nota: number) {
    const primeira = this.resposta.nota === null;
    this.resposta.nota = nota; this.msgErro = '';
    // No celular, a primeira escolha leva a pessoa ao comentário sem abrir o teclado.
    if (primeira && typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches) {
      setTimeout(() => document.getElementById('blocoComentario')?.scrollIntoView({behavior: 'smooth', block: 'start'}), 150);
    }
  }
  async carregueAvaliacao() {
    const contexto = ++this.contexto;
    this.carregando = true; this.enviado = false; this.enviando = false; this.msgErro = '';
    this.avaliacao = null; this.resposta = {nota: null, comentario: ''};
    try {
      const avaliacao = await this.nps.obtenha(this.token);
      if (contexto !== this.contexto) return;
      this.avaliacao = avaliacao; this.enviado = avaliacao.estado === 'RESPONDIDA';
    } catch (erro) {if (contexto === this.contexto) this.msgErro = String(erro || 'Não foi possível carregar a pesquisa.');}
    finally {if (contexto === this.contexto) this.carregando = false;}
  }
  async enviarAvaliacao() {
    if (this.enviando || this.enviado) return;
    if (this.resposta.nota === null) {this.msgErro = 'Selecione uma nota de 0 a 10.'; return;}
    this.enviando = true; this.msgErro = '';
    const contexto = this.contexto;
    try {
      await this.nps.responda(this.token, {nota: this.resposta.nota, comentario: this.resposta.comentario});
      if (contexto === this.contexto) this.enviado = true;
    } catch (erro) {if (contexto === this.contexto) this.msgErro = String(erro || 'Não foi possível enviar sua avaliação.');}
    finally {if (contexto === this.contexto) this.enviando = false;}
  }
}
